import { on } from '@ember/modifier';
import { action } from '@ember/object';
import { service } from '@ember/service';
import Component from '@glimmer/component';

import type { Service } from 'webapp-types';

import didInsert from 'webapp/modifiers/did-insert';

type Args = Record<string, never>;

export default class TopbarZoomComponent extends Component<Args> {
	@service('current-user') declare currentUserService: Service.CurrentUser;

	node: HTMLElement | null = null;

	zoomValues = {
		min: 80,
		max: 200,
	};

	get currentZoom() {
		return this.currentUserService.mobileBoardZoom;
	}

	@action
	decreaseZoom() {
		const node = this.node;
		if (node && this.currentZoom > this.zoomValues.min) {
			$(node).slider('value', this.currentZoom - 20);
		}
	}

	@action
	increaseZoom() {
		const node = this.node;
		if (node && this.currentZoom < this.zoomValues.max) {
			$(node).slider('value', this.currentZoom + 20);
		}
	}

	@action
	setupView(node: HTMLElement) {
		this.node = node;

		$(this.node)
			.slider({
				min: this.zoomValues.min,
				max: this.zoomValues.max,
				step: 20,
				value: this.currentZoom,
			})
			.on('slidechange', (_event: unknown, ui: { value: number }) => {
				this.currentUserService.updateMobileBoardZoom(ui.value);
			});
	}
	<template>
		<div id="deviceZoom">
			<span>{{this.currentZoom}}%</span>
			<div>
				<div id="zoom" {{didInsert this.setupView}}></div>
				<a role="button" class="plus" {{on "click" this.increaseZoom}}>+</a>
				<a role="button" class="minus" {{on "click" this.decreaseZoom}}>−</a>
			</div>
		</div>
	</template>
}
